import { navigateTo } from '../../../../../common/frontend/route-utils.js'
import { t } from '../../../../../common/i18n.js'
import { Language } from '../../../../../common/types/i18n.js'
import { formatDisplayDate } from '../../../../../common/utils/format-utils.js'
import { PortalAvatar } from '../../../../components/portal-avatar/portal-avatar.js'
import { formatDaysUntil } from '../../utils/format.js'
import type { UpcomingEvent } from '../../utils/portal-api.js'
import { eventIcon, eventLabel } from './event-format.js'

export interface EventsTabProps {
    events: UpcomingEvent[]
    isLoading: boolean
    lang: Language
}

export const EventsTab = ({ events, isLoading, lang }: EventsTabProps) => {
    const ph = t.portal.people

    if (isLoading) {
        return (
            <div className="portal-people__empty">
                <div className="portal-people__empty-text">{t.portal.profile.loading(lang)}</div>
            </div>
        )
    }

    if (events.length === 0) {
        return (
            <div className="portal-people__empty">
                <div className="portal-people__empty-text">{ph.noEvents(lang)}</div>
            </div>
        )
    }

    return (
        <div className="portal-people__events">
            <h2 className="portal-people__events-title">{ph.upcomingEvents(lang)}</h2>
            <div className="portal-people__list">
                {events.map((ev, i) => {
                    const name = `${ev.firstName} ${ev.lastName}`
                    return (
                        <div
                            key={`${ev.type}-${ev.employeeId}-${i}`}
                            className="portal-people__row"
                            onClick={() => navigateTo(`/people/${ev.employeeId}`)}
                        >
                            <PortalAvatar
                                name={`${ev.firstName} ${ev.lastName}`}
                                avatarUrl={ev.avatarUrl}
                                size="sm"
                            />
                            <div className="portal-people__row-id">
                                <div className="portal-people__row-name">
                                    {name}
                                    <span
                                        className={`portal-people__event-badge portal-people__event-badge--${ev.type}`}
                                    >
                                        {eventIcon(ev.type)}
                                        {eventLabel(ev, lang)}
                                    </span>
                                </div>
                                <div className="portal-people__row-sub">{ev.jobTitle ?? ''}</div>
                            </div>
                            <div className="portal-people__row-when">
                                <div className="portal-people__row-date">
                                    {formatDisplayDate(ev.date)}
                                </div>
                                <div className="portal-people__row-rel">
                                    {formatDaysUntil(ev.daysUntil, lang)}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
